// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { FlexRow, spacing } from '@alto/pocky';
import React, { PureComponent } from 'react';
import { type PrescriptionsWithAncillaries } from '~shared/features/my-meds/types';
import { getAncillariesFromPrescription } from '~shared/helpers/ancillaries';
import { isControl } from '~shared/helpers/helper';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { type Prescription } from '~shared/types';
import MedListPrice from './MedListPriceContainer';
import { Ancillaries } from './ancillaries/Ancillaries';
import { NextAvailableDateInfoRow } from '~web/features/my-meds/components/NextAvailableDateInfoRow';
import NotCoveredByInsuranceInfoRow from '~web/features/my-meds/components/NotCoveredByInsuranceInfoRowContainer';
import SignatureRequiredTag from '~web/features/my-meds/components/SignatureRequiredTag';

export type Props = {
  readonly paymentLabel: string | null | undefined;
  readonly prescription: Prescription;
  readonly price: string | null | undefined;
  readonly priceLabel: string | null | undefined;
  readonly priceLabelInfo: string | null | undefined;
  readonly ancillaries: PrescriptionsWithAncillaries;
};

export default class MedListPriceInfo extends PureComponent<Props> {
  render() {
    const { paymentLabel, prescription, price, priceLabel, priceLabelInfo, ancillaries } = this.props;
    const mappedAncillaries = getAncillariesFromPrescription(ancillaries, prescription.id);
    const signatureRequired = isControl(prescription);
    return (
      <FlexRow spacing={spacing.smSpacing}>
        <FlexRow>
          <NextAvailableDateInfoRow
            prescription={prescription}
            origin={ORIGIN_NAMES.MED_LIST}
          />
          <NotCoveredByInsuranceInfoRow prescription={prescription} />
          {signatureRequired ? <SignatureRequiredTag medicationName={prescription.medication_name || 'This'} /> : null}
        </FlexRow>
        {mappedAncillaries.length > 0 ? <Ancillaries list={mappedAncillaries} /> : null}
        <MedListPrice
          prescription={prescription}
          paymentLabel={paymentLabel}
          price={price}
          priceLabel={priceLabel}
          priceLabelInfo={priceLabelInfo}
        />
      </FlexRow>
    );
  }
}
